module.exports = {
  create_button_label: 'Создать шаблон',
  page_title: 'Шаблоны оценок',
  template_settings: 'Настройка шаблона',
  approve_button: 'Сохранить',
  cancel_button: 'Отменить',
  criteria_eq: 'Равно',
  criteria_range: 'Диапазон',
  scale_name: 'Название шкалы оценки',
  rating_scale_type: 'Условие',
  rating_scale_condition: 'Значение',
  rating_scale_value: 'Балл',
  rating_scale_rating: 'Балл',
  rating_scale_description: 'Описание',
  rating_scale_color: 'Цвет',
  rating_scale_icon: 'Иконка',
  rating_scale_default_value: 'По умолчанию',
  add_scale: 'Добавить оценку',
  hints: {
    setting: 'Настроить',
    copy: 'Копировать',
    delete: 'Удалить'
  },
  table: {
    name: 'Название шаблона',
    dt_add: 'Дата создания',
    dt_update: 'Дата обновления',
    actions: 'Действия'
  },
  remove_modal_desc: 'Удаленный шаблон будет невозможно вернуть.'
}
